import { createSlice } from "@reduxjs/toolkit";
import { fetchMapStudentsGPIStatsData } from "../thunks/dashboardThunk"; 

const dashboardSchoolsGPIMapStateInt = createSlice({
  name: "MapSchoolsGPIStatsInt",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

 
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchMapStudentsGPIStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMapStudentsGPIStatsData.fulfilled, (state, action) => {
        state.data = action.payload.data===""?[]:action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMapStudentsGPIStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboardSchoolsGPIMapStateInt.reducer;